import { CmsApplianceDetailsModelSerialBenefitsPanel } from '../../models/appliance-details-model-serial/cms-appliance-details-model-serial-benefits-panel.interface';

export const mockCmsApplianceDetailsModelSerialBenefitsPanel: CmsApplianceDetailsModelSerialBenefitsPanel =
  {
    benefits: {
      item0: {
        body: 'Benefit 1',
        icon: {
          name: 'shield-check',
        },
      },
      item1: {
        body: 'Benefit 2',
        icon: {
          name: 'dog',
        },
      },
      item2: {
        body: '<strong>Benefit 3</strong>',
        icon: {
          name: 'horse',
        },
      },
    },
    title: 'string',
  };
